import React from 'react';
import { Divider, TextLink, Typography } from '@guildeducationinc/recess';
import { buEligibility } from '@src/utilities/urlUtility';
import { useMemberExperienceAuth } from '@guildeducationinc/auth-frontend-tools';
import styles from './EligibilityPopoverContent.module.scss';

export interface EligibilityPopoverContentProps {
	tagCopy: string;
	tenureDays?: number;
}

export const EligibilityPopoverContent: React.ComponentType<EligibilityPopoverContentProps> = ({
	tagCopy,
	tenureDays,
}) => {
	const { userFromIdToken: authUser } = useMemberExperienceAuth();
	const employerName = authUser?.employer || 'your employer';

	let popoverMessage = '';
	if (tagCopy === 'Not eligible') {
		popoverMessage = `You have lost access due to ${employerName}'s eligibility requirements.`;
	}
	if (tagCopy === 'Eligible soon' && tenureDays) {
		popoverMessage = `You will have access to this program once you have worked at ${employerName} for ${tenureDays} days.`;
	}
	if (tagCopy === 'Eligible soon' && !tenureDays) {
		popoverMessage = `You'll have access to this program once you've completed ${employerName}'s tenure period.`;
	}

	return (
		<div className={styles.popoverContent}>
			<Typography className={styles.popoverText} variant='body1'>
				{popoverMessage}
			</Typography>
			<Divider className={styles.popoverDivider} opacity='2' />
			<TextLink className={styles.popoverLink} href={buEligibility} variant='standalone'>
				Learn more
			</TextLink>
		</div>
	);
};
